import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { usePathParam } from '@chilecompra/react-kit'
import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'
import { onCancelBidHideDialogSuccess, onCancelBidThunk } from './CancelBidSellerDialog.actions'
import { Grid } from './CancelBidSellerDialog.styles'
import Errors from '../../components/Custom/Errors'
import { getCookieFromDomain } from '../../modules/cookies'
import { inIframe } from '../../modules/utils/inIframe'
import { topPage } from '../../modules/utils/topPage'

/**
 * The CancelBidSellerDialog's container.
 */
const CancelBidSellerDialog = () => {
  const { bidId, errors, loading, open } = useSelector(state => state.cancelBidSellerDialog)
  const dispatch = useDispatch()
  const quoteId = usePathParam('quoteId')
  const userInfo = Object.fromEntries(new URLSearchParams(getCookieFromDomain('user_info')))

  const isInIframe = useMemo(() => inIframe(), [])

  const handleOnClose = () => dispatch(onCancelBidHideDialogSuccess())
  const handleOnCancelBid = () => dispatch(onCancelBidThunk({ bidId, quoteId, ipUsuario: userInfo.host || '' }))

  useEffect(() => topPage(isInIframe, open), [open])

  return (
    <Dialog maxWidth="505px" onClose={handleOnClose} open={open} verticalAlign="top">
      <Typography
        align="center"
        color="black1"
        fontSize="18px"
        fontWeight="bold"
        lineHeight="22px"
        margin="64px 0 12px"
        variant="h4"
      >
        Anular envío de cotización
      </Typography>
      <Typography align="center" color="black1" fontSize="14px" lineHeight="16px" margin="0 64px 8px" variant="body2">
        Se eliminará la cotización ID {bidId}. Esta acción es irreversible.
      </Typography>
      <Typography align="center" color="black1" fontSize="14px" lineHeight="16px" margin="0 0 32px" variant="body2">
        ¿Está seguro que desea continuar?
      </Typography>
      <Grid container justifyContent="center">
        <Button color="error" loading={loading} margin="0 0 8px" onClick={handleOnCancelBid}>
          Eliminar cotización
        </Button>
      </Grid>
      <Grid container justifyContent="center">
        <Button variant="outlined" loading={loading} margin="0 0 32px" onClick={handleOnClose}>
          Cancelar
        </Button>
      </Grid>
      <Errors errors={errors} />
    </Dialog>
  )
}

export default CancelBidSellerDialog
